import React, { useState } from "react";
import "./Footer.css";
import TermsAndConditions from "components/TermsAndCondition/TermsAndConditions";

const Footer: React.FC = () => {
  const [isTermsOpen, setIsTermsOpen] = useState(false);

  const toggleTerms = () => {
    setIsTermsOpen(!isTermsOpen);
  };
  return (
    <footer className="footer">
      <div className="footer-content">
      <span className="terms" onClick={toggleTerms}>Terms and Conditions</span>
        {isTermsOpen && <TermsAndConditions onClose={toggleTerms} />}
        <span className="copyright">© 2025 NepMaster.com</span>
      </div>
    </footer>
  );
};

export default Footer;
